import React, { ReactElement, memo } from 'react'
import type { UrlObject } from './types/models'

type ProductImageProps = {
  title: string;
  urls: UrlObject;
}

const ProductImage = ({ title, urls }: ProductImageProps): ReactElement => (
  <div className="basket-item-product-image">
    <picture>
      {
        urls.webp &&
          <source type="image/webp" srcSet={`${urls.webp} 1.5x`} />
      }
      {
        urls.jpeg &&
          <source type="image/jpeg" srcSet={`${urls.jpeg} 1.5x`} />
      }
      <img src={urls.default} alt="" title={title} loading="lazy" height="200" width="200" />
    </picture>
  </div>
)

export default memo(ProductImage)
